module.exports = __webpack_public_path__ + "media/feature/background1-59a10183.png";